/*
 * View for the search pane of the Topics Area
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/accountAdmin/kbWizardModal/kbLocales/kbLocalesSearch/template/kbLocalesSearchTemplate.html",
  "modules/typeahead/typeaheadModel",
], function (Marionette, Messenger, KbLocalesListTemplate, TypeaheadModel) {
  var KbLocalesSearchView = {};

  KbLocalesSearchView.kbLanguageAvailableSearchView = Marionette.ItemView.extend({
    template: KbLocalesListTemplate,

    modelEvents: {
      change: "render",
    },

    triggers: {
      "submit form": "click:addLanguage",
    },

    onRender: function () {
      this.$el.i18n();

      //set up source function to get the typeahead data
      var _this = this;
      var sourceFunction = function (query, process) {
        var results = Messenger.reqres.request("language:all:typeahead", query);
        results.once(
          "sync",
          function () {
            process(results.getResultsArray());
          },
          this,
        );
      };
      //this handler prevents typeahead from using the "enter" keypress to search by the typeahead suggestion
      this.$el.find("input").on("keyup", function (e) {
        if (e.keyCode == 13) {
          e.stopImmediatePropagation(); //stop typeahead from getting this event
          //now we need to trigger the click:search event, because the propagation was stopped
          _this.trigger("click:search", { view: _this, model: _this.model });
          //and close the typeahead as well
          _this.$el.find(".typeahead").hide();
        }
      });

      this.$el.find("input").typeahead({
        source: sourceFunction,
        updater: function (item) {
          //set the value of the textbox
          _this.$el.find("input").val(item);
          _this.trigger("click:search", { view: _this, model: _this.model }); //trigger event on view, passing the standard args hash
          return item;
        },
      });
    },

    clearInput: function () {
      this.$el.find("input").val("");
      this.$el.find(".typeahead").hide();
    },
  });

  return KbLocalesSearchView;
});
